module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av403-7b7d4a43ec42dbb6fc5ca275ffa8072b.jpg";